<template>
    <v-card rounded="lg" outlined>
        <v-card-title>
            <v-row class="ma-0">
                <v-col cols="12" md="auto" class="min-w-md-200px min-w-lg-280px">
                    <item-company v-bind="{ value }" />
                </v-col>
                <v-col cols="12" md="">
                    <v-row align="center">
                        <v-col cols="12" md="auto">
                            <h5 class="page-text--lg font-weight-medium">
                                <span> {{ value?.subject }} </span>
                                <span class="page-text--sm"> ({{ value?.form?.name }}) </span>
                            </h5>
                        </v-col>
                        <v-col cols="12" md="auto">
                            <template v-if="value.isSigned">
                                <v-chip label color="primary">
                                    <v-icon size="16" class="ml-4">mdi-check</v-icon>
                                    <span> 서명완료 </span>
                                </v-chip>
                            </template>
                            <template v-else>
                                <v-chip label color="grey-ec" text-color="grey-1">
                                    <v-icon size="16" class="mr-4">mdi-minus</v-icon>
                                    <span> 서명대기 </span>
                                </v-chip>
                            </template>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text>
            <v-row align="center">
                <v-col cols="12" lg="auto">
                    <item-meta v-bind="{ value }" />
                </v-col>
                <v-spacer />
                <v-col cols="12" lg="auto">
                    <template v-if="value.isSigned">
                        <employment-contract-view v-bind="{ value }">
                            <template #activator="{ attrs, on }">
                                <v-btn v-bind="attrs" v-on="on" small outlined color="primary">
                                    <span> 자세히 보기 </span>
                                </v-btn>
                            </template>
                        </employment-contract-view>
                    </template>
                    <template v-else>
                        <employment-contract-sign v-bind="{ value }" v-on="{ search }">
                            <template #activator="{ attrs, on }">
                                <v-btn v-bind="attrs" v-on="on" small outlined color="primary">
                                    <span> 서명하기 </span>
                                </v-btn>
                            </template>
                        </employment-contract-sign>
                    </template>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import { initEmploymentContract } from "@/assets/variables";

import EmploymentContractSign from "./employment-contract-sign.vue";
import EmploymentContractView from "@/components/dashboard/common/employment/contract/employment-contract-view.vue";
import ItemCompany from "./item/item-company.vue";
import ItemMeta from "./item/item-meta.vue";

export default {
    components: {
        EmploymentContractSign,
        EmploymentContractView,
        ItemCompany,
        ItemMeta,
    },
    props: {
        value: { type: Object, default: initEmploymentContract },
    },
    methods: {
        search() {
            this.$emit("search");
        },
    },
};
</script>

<style lang="scss" scoped>
.v-chip {
    &::before {
        display: none;
    }
}
.v-chip.v-size--default {
    font-weight: 500;
    height: 28px;
    font-size: 1.2rem;
    padding: 0 12.4444444444px;
}
@media (min-width: 1024px) {
    .v-chip.v-size--default {
        height: 36px;
        font-size: 1.4rem;
    }
}
</style>
